import React from 'react';
import { BodyText, FormModal, PrimaryButton, TextAreaField, TextField, useModalProps } from '@kallidus/common';
import { useTranslation } from 'react-i18next';
import useContactUsButtons from '@Generic/ContactUsModal/useContactUsButtons';
import { bool, string } from 'prop-types';
import formatUser from '@Utils/formatUser';
import useContactUsSubmit from '@Generic/ContactUsModal/useContactUsSubmit';
import { SuccessModal } from '@Generic/modals/InformationalModal';
import { useLoggedInUser } from '@ApplicationWide/AppConfig';
import { SAPLING_PRODUCT_INFO_URL } from '@ApplicationWide/constants/external_urls';

const ContactUsModal = ({ title, subTitle, message, isExpireTrial = false, origin, ...modalProps }) => {
  const { t } = useTranslation();
  const { user } = useLoggedInUser();
  const { modalProps: successModalProps, openModal: openSuccessModal } = useModalProps();
  const handleSubmit = useContactUsSubmit(user, origin, openSuccessModal);
  const renderButtons = useContactUsButtons();
  const isClosable = !isExpireTrial;

  return (
    <>
      <FormModal
        renderButtons={renderButtons}
        formId='contact-us-modal'
        title={title}
        {...modalProps}
        onSubmit={handleSubmit}
        closable={isClosable}
        keyboard={isClosable}
        maskClosable={isClosable}
        initialValues={{
          name: formatUser('displayName', user),
          email: user.email,
          message: message,
        }}
      >
        <BodyText noTopSpacer bold>
          {subTitle}
        </BodyText>
        <TextField
          name='name'
          label={t('pay-wall.contact-us-modal.fields.name')}
          required
          emptyMessage={t('std-form.invalid-empty-field')}
        />
        <TextField
          required
          emptyMessage={t('std-form.invalid-empty-field')}
          name='email'
          label={t('pay-wall.contact-us-modal.fields.email')}
        />
        <TextAreaField
          name='message'
          label={t('pay-wall.contact-us-modal.fields.message')}
          required
          emptyMessage={t('std-form.invalid-empty-field')}
        />
      </FormModal>
      <SuccessModal
        title={t('pay-wall.contact-success-modal.title')}
        message={t('pay-wall.contact-success-modal.sub-title')}
        closable={isClosable}
        maskClosable={isClosable}
        footer={
          <PrimaryButton href={SAPLING_PRODUCT_INFO_URL} target='_blank'>
            {t('pay-wall.contact-us-modal.explore-plans-cta')}
          </PrimaryButton>
        }
        {...successModalProps}
      />
    </>
  );
};

ContactUsModal.propTypes = {
  message: string,
  origin: string,
  title: string,
  isExpireTrial: bool,
  subTitle: string,
};

export default ContactUsModal;
